module.exports = __webpack_public_path__ + "static/miguel_-34d1cb0a429f7412bf7975005abd5889.png";